import React from 'react';
import { Company } from '../types';

interface LoginViewProps {
  onSelectCompany: (company: Company) => void;
}

export const LoginView: React.FC<LoginViewProps> = ({ onSelectCompany }) => {
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col items-center justify-center p-4 animate-in fade-in duration-500">
      {/* Brand Header */}
      <div className="text-center mb-8">
        <h1 className="text-4xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-orange-400 mb-1.5 tracking-tight">
          Gestão
        </h1>
        <p className="text-slate-400 text-sm font-light tracking-[0.2em] uppercase">Colaboradores</p>
      </div>

      {/* Main Container */}
      <div className="bg-white rounded-xl shadow-xl shadow-slate-200/50 w-full max-w-3xl p-6 md:p-8 border border-white">
        <h2 className="text-center text-slate-800 text-base font-medium mb-6">
          Selecione a Empresa
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Sanpack */}
          <button 
            onClick={() => onSelectCompany('Sanpack')}
            className="group relative flex flex-col items-center p-4 rounded-xl bg-[#F1F5F9] border border-transparent transition-all hover:bg-white hover:border-slate-100 hover:shadow-2xl hover:shadow-orange-500/5 hover:-translate-y-1"
          >
            <div className="size-16 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform">
               <span className="material-symbols-outlined !text-[24px] text-white">factory</span>
            </div>
            <h3 className="text-sm font-semibold text-slate-800 mb-0.5">Sanpack</h3>
            <p className="text-[8px] text-slate-400 uppercase tracking-widest font-bold">Indústria</p>
          </button>

          {/* Sanplast */}
          <button 
            onClick={() => onSelectCompany('Sanplast')}
            className="group relative flex flex-col items-center p-4 rounded-xl bg-[#F1F5F9] border border-transparent transition-all hover:bg-white hover:border-slate-100 hover:shadow-2xl hover:shadow-blue-500/5 hover:-translate-y-1"
          >
            <div className="size-16 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform">
               <span className="material-symbols-outlined !text-[24px] text-white">factory</span>
            </div>
            <h3 className="text-sm font-semibold text-slate-800 mb-0.5">Sanplast</h3>
            <p className="text-[8px] text-slate-400 uppercase tracking-widest font-bold">Indústria</p>
          </button>

          {/* GSan (ADMINISTRATIVO) */}
          <button 
            onClick={() => onSelectCompany('GSan (ADMINISTRATIVO)')}
            className="group relative flex flex-col items-center p-4 rounded-xl bg-[#F1F5F9] border border-transparent transition-all hover:bg-white hover:border-slate-100 hover:shadow-2xl hover:shadow-orange-400/5 hover:-translate-y-1"
          >
            <div className="size-16 rounded-full bg-[linear-gradient(135deg,#2563EB_50%,#F97316_50%)] flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform">
               <span className="material-symbols-outlined !text-[24px] text-white">corporate_fare</span>
            </div>
            <h3 className="text-sm font-semibold text-slate-800 mb-0.5 text-center leading-tight">GSan</h3>
            <p className="text-[8px] text-slate-400 uppercase tracking-widest font-bold">Administrativo</p>
          </button>
        </div>
      </div>

      <div className="mt-8 text-slate-300 text-[9px] font-bold uppercase tracking-[0.3em]">
        GSan &bull; 2026
      </div>
    </div>
  );
};